import { createRoot } from 'react-dom/client';
import { ClerkProvider } from '@clerk/clerk-react';
import { SupabaseClientProvider } from './contexts/supabase/SupabaseClientProvider';
import App from './App.tsx';
import './index.css';
import { initSentry } from './lib/sentry';

initSentry();

const defaultKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;
const devKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY_DEV;
const prodKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY_PROD;

let publishableKey = defaultKey || '';
if (typeof window !== 'undefined') {
  const host = window.location.host.toLowerCase();
  const matchesProdDomain = /(^|\.)ntnuipadel\.no$/.test(host);

  if (matchesProdDomain && prodKey) {
    publishableKey = prodKey;
  } else if (!matchesProdDomain && devKey) {
    publishableKey = devKey;
  }
}

if (!publishableKey) {
  publishableKey = import.meta.env.PROD ? prodKey || '' : devKey || '';
}

if (!publishableKey) {
  throw new Error('Missing Clerk Publishable Key');
}

createRoot(document.getElementById('root')!).render(
  <ClerkProvider publishableKey={publishableKey} afterSignOutUrl="/">
    <SupabaseClientProvider>
      <App />
    </SupabaseClientProvider>
  </ClerkProvider>
);
